const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDynamicCustomOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.943 0.506 L 0.943 22.506 L 6.943 22.506 L 6.943 40.506 L 20.943 16.506 L 12.943 16.506 L 18.943 0.506 L 0.943 0.506 Z",
    fill: "black",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)",
      paintOrder: "stroke",
      fillRule: "nonzero",
      stroke: "rgb(255, 255, 255)",
      strokeWidth: 4
    },
    d: "M 1.91 38.318 L 20.359 2.694"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2,
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 0, 0)"
    },
    d: "M 0.918 40.455 L 20.969 0.557"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicCustomOff);
export default __webpack_public_path__ + "static/media/dynamicCustomOff.2816e182743f60b54c7099b5ce9db5f9.svg";
export { ForwardRef as ReactComponent };